import * as React from 'react'

import { Box, Icon, Text, Tooltip, useToggle } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

export default function OvertimeExplainer() {
  const [open, toggle] = useToggle()

  return (
    <Box alignItems="center">
      <Tooltip.ItemList
        attachment="top center"
        targetAttachment="bottom center"
        open={open}
        toggle={toggle}
      >
        <Box
          gap="s8"
          alignItems="center"
          cursor="pointer"
          flexDirection="row"
          justifyContent="spaceBetween"
        >
          <Icon.Medium icon="info-circle-line" color="grey800" />
        </Box>
        <Box alignItems="center">
          <Text.Normal size="200">{i18n.t('time_off.overtime_explainer.description')}</Text.Normal>
        </Box>
      </Tooltip.ItemList>
    </Box>
  )
}
